// extracted by mini-css-extract-plugin
export default {"page_title_container":"PageTitle_page_title_container__YcePC","is_container":"PageTitle_is_container__CL6NS"};